import logo from "../../../../public/projects/Hiranandani/logo/logo.png"
import vista from "../../../../public/projects/Hiranandani/projects/Vista.jpg"
import Regent from "../../../../public/projects/Hiranandani/projects/Regent.jpg"
import Gardens from "../../../../public/projects/Hiranandani/projects/Gardens.jpg"
import Empress from "../../../../public/projects/Hiranandani/projects/Empress.jpg"


//Hiranandani
import overviewImage_vista from "../../../../public/projects/Hiranandani/images/vista/Overview/1.webp";
import bannerDesktopImage_vista from "../../../../public/projects/Hiranandani/images/vista/Banner/1.webp";
import bannerMobileImage_vista from "../../../../public/projects/Hiranandani/images/vista/Banner/2.webp";
import siteVisitBannerImage_vista from "../../../../public/projects/Hiranandani/images/vista/SiteVisitBanner/1.webp";
import Location_vista from "../../../../public/projects/Hiranandani/images/vista/Location/L1.webp";
import Hightlights_vista from "../../../../public/projects/Hiranandani/images/vista/Highlights/1.webp";
import image1BHK_vista from "../../../../public/projects/Hiranandani/images/vista/floorplan/1.webp";
import image2BHK_vista from "../../../../public/projects/Hiranandani/images/vista/floorplan/2.webp";
import location_vista from "../../../../public/projects/Hiranandani/images/vista/Overview/l.png";
import cal_vista from "../../../../public/projects/Hiranandani/images/vista/Overview/c.png";
import newlaunch_vista from "../../../../public/projects/Hiranandani/images/vista/Overview/n.png";
import g1_vista from "../../../../public/projects/Hiranandani/images/vista/Gallery/1.webp";
import g2_vista from "../../../../public/projects/Hiranandani/images/vista/Gallery/2.webp";
import g3_vista from "../../../../public/projects/Hiranandani/images/vista/Gallery/3.webp";
import g4_vista from "../../../../public/projects/Hiranandani/images/vista/Gallery/4.webp";
import g5_vista from "../../../../public/projects/Hiranandani/images/vista/Gallery/5.webp";


//Regent Hill
import overviewImage_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Overview/1.webp";
import bannerDesktopImage_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Banner/1.webp";
import bannerMobileImage_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Banner/2.webp";
import siteVisitBannerImage_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/SiteVisitBanner/1.webp";
import Location_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Location/L1.webp";
import Hightlights_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Highlights/1.webp";
import image1BHK_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/floorplan/1.webp";
import location_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Overview/l.png";
import cal_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Overview/c.png";
import newlaunch_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Overview/n.png";
import g1_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Gallery/1.webp";
import g2_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Gallery/2.webp";
import g3_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Gallery/3.webp";
import g4_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Gallery/4.webp";
import g5_regenthill from "../../../../public/projects/Hiranandani/images/regenthill/Gallery/5.webp";


export const developersHiranandani = {
  name: `Hiranandani Group Properties in Mumbai`,
  properties: [
    {
      name: "Hiranandani Group - Vista Residences",
      image:vista,
      price: "On Request",
      location: "West Mumbai",
      bed: "2 - 3 BHK",
      state: "Mumbai",
      developer: "Hiranandani Group",
      size: "....",
      url: `/hiranandani-vista-residences-andheri-west-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Hiranandani Group - Regent Hill",
      image: Regent,
      price: "On Request",
      location: "Mumbai",
      projectlocation: "Powai, Mumbai",
      state: "Mumbai",
      developer: "Hiranandani Group",
      bed: "1 BHK Apartments",
      size: "378 - 390 sq.ft.",
      url: `/hiranandani-regent-hill-powai-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    // {
    //     name: "Hiranandani Group - Gardens",
    //     image:Gardens,
    //     price: "On Request",
    //     location: "Mumbai",
    //     projectlocation: "Powai, Mumbai",
    //     state: "Mumbai",
    //     developer: "Hiranandani Group",
    //     bed: "3 & 4 BHK Apartments",
    //     size: "On Request",
    //     url: `/developers/birla/birla-estate`,
    //     form: {
    //       source_id: 11,
    //       api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //       sub_source_id: 130,
    //       builder_id: `103`,
    //       project_id: `477`,
    //       subject: "M3M Altitude", // Add or update the subject here
    //       to_email: "jatin.rohilla@propertystation.in",
    //     },
    //   },
      // {
      //   name: "Hiranandani Group - Highland",
      //   image: "",
      //   price: "On Request",
      //   location: "Mumbai",
      //   projectlocation: "Wellesley Road",
      //   state: "Mumbai",
      //   developer: "Hiranandani Group",
      //   bed: "1 - 3 BR Apartments",
      //   size: "On Request",
      //   url: `/developers/birla/birla-estate`,
      //   form: {
      //     source_id: 11,
      //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      //     sub_source_id: 130,
      //     builder_id: `103`,
      //     project_id: `477`,
      //     subject: "M3M Altitude", // Add or update the subject here
      //     to_email: "jatin.rohilla@propertystation.in",
      //   },
      // },
      // {
      //   name: "Hiranandani Group - Empress Hill",
      //   image: Empress,
      //   price: "On Request",
      //   location: "Mumbai",
      //   projectlocation: "Powai, Mumbai",
      //   state: "Mumbai",
      //   developer: "Hiranandani Group",
      //   bed: "2 - 3- 4 BR Apartments",
      //   size: "On Request",
      //   url: `/developers/birla/birla-estate`,
      //   form: {
      //     source_id: 11,
      //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      //     sub_source_id: 130,
      //     builder_id: `103`,
      //     project_id: `477`,
      //     subject: "M3M Altitude", // Add or update the subject here
      //     to_email: "jatin.rohilla@propertystation.in",
      //   },
      // },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1969",
  },
  about: `Founded in 1969, Kalpataru Limited is a well-known Indian real estate firm. For more than 50 years, we have been establishing new benchmarks in real estate development and have won multiple international accolades for our design and quality. Our goal is to construct houses and offices that are both sustainable and value-driven. By being customer-centric, open, and attentive to their requirements, we put our connections with customers first.
`,
};


export const projectshiranandani = {
  vistaresidences: {
    bannerdata:{
      bannerDesktopImage:bannerDesktopImage_vista,
      bannerMobileImage:bannerMobileImage_vista,
      textOverlay: "",
      data:{
        title:"Hiranandani Vista Residences",
        subtitle:"Andheri West, Mumbai",
        starting_price:"2.95 Cr",
        rerano:"P51800053625",
        payment_plan:"CLP",
        status:"New Launch"
      }
    },
    overview: {
      heading: "Vista Residences, Andheri West - Luxury Homes by Hiranandani Group",
      description: [
      `Hiranandani Vista Residences, developed by the renowned Hiranandani Group, is a premium residential project in Andheri West, Mumbai. Designed for modern living, it offers spacious apartments with high-end finishes, contemporary architecture, and breathtaking city views.

Located in Andheri West, one of Mumbai’s most sought-after neighborhoods, the project provides excellent connectivity to Western Express Highway, metro stations, business hubs, entertainment zones, schools, and healthcare facilities.

Hiranandani Vista Residences features world-class amenities, including a clubhouse, swimming pool, fitness center, landscaped gardens, jogging track, children’s play area, and 24/7 security.

With its prime location, luxurious design, and top-tier facilities, Hiranandani Vista Residences is an ideal investment for those seeking an upscale lifestyle in Mumbai.
`,
      ],
      image: overviewImage_vista,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_vista,
          title: "2.95 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_vista,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_vista,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_vista,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "766 - 850 sq. ft.",
          price: "2.95 - 3.7 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1111.16 - 1170.8 sq. ft.",
          price: "4.54 - 4.78 Cr",
          eoiAmount: "On Request",
        },
       
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
          area: "766 - 850 sq. ft.",
          price: "2.95 - 3.7 Cr",
        image: image1BHK_vista,
      },
      {
        type: "3 BHK",
          area: "1111.16 - 1170.8 sq. ft.",
          price: "4.54 - 4.78 Cr",
        image: image2BHK_vista,
      },
     
    ],

    highlights: {
      images: Hightlights_vista,
      tagline: "Highlights",
      features: [
        "Striking elevation with modern architecture",
        "Vicino mall with all commercial brands",
        "Spacious apartments with balcony",
        "Rooftop swimming pool",
        "Metro station right beside",
      ],
    },

    location: {
      image: Location_vista,
      data:[
        {
          airport:{
            distance_time:"10.6 Km",
            name:"Mumbai Airport"
          },
          school:{
            distance_time:"1.1 Km",
            name:"RIMS School"
          },
          railwayormetro:{
            distance_time:"750 m",
            name:"Goregaon Metro Station"
          },
          hospital:{
            distance_time:"3.6 Km",
            name:"Ambani Hospital"
          },
          mall:{
            distance_time:"100 m",
            name:"Vicino Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_vista },
        { image: g2_vista },
        { image: g3_vista },
        { image: g4_vista },
        { image: g5_vista },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Hiranandani Vista Residences, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Vista Residences?",
        answer: `Vista Residences is developed by the Hiranandani Group.` },
      {
        question: "Where is Vista Residences located?",
        answer: `The project is located in Andheri West, Mumbai.`  },
      {
        question: "What types of apartments are available at Vista Residences?",
        answer: `The project offers 2 BHK and 3 BHK apartments.
`},
      {
        question: "What is the size range of 2 BHK apartments?",
        answer: `The 2 BHK apartments range from 766 to 850 sq. ft.
`  },
      {
        question: "What is the price range of 2 BHK apartments?",
        answer: `The price of 2 BHK apartments starts at ₹2.95 Cr and goes up to ₹3.7 Cr.`  },
      {
        question: "What is the size range of 3 BHK apartments?",
        answer: `The 3 BHK apartments range from 1111.16 to 1170.8 sq. ft.` },
      {
        question: "What is the price range of 3 BHK apartments?",
        answer: `The price of 3 BHK apartments starts at ₹4.54 Cr and goes up to ₹4.78 Cr.`  },
      {
        question: "What is the starting price of apartments at Vista Residences?",
        answer: `The starting price for apartments at Vista Residences is ₹2.95 Cr.
`   },
      {
        question: "What is the current status of Vista Residences?",
        answer: `Vista Residences is a newly launched project.`   },
      {
        question: "Is Vista Residences located in a prime area?",
        answer: `Yes, Andheri West is a prime and well-connected location in Mumbai.` },
    ],
    similar:{
      properties: [
       
        {
          name: "Hiranandani Group - Regent Hill",
          image: Regent,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "Powai, Mumbai",
          state: "Mumbai",
          developer: "Hiranandani Group",
          bed: "1 BHK Apartments",
          size: "378 - 390 sq.ft.",
          url: `/hiranandani-regent-hill-powai-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        // {
        //     name: "Hiranandani Group - Gardens",
        //     image:Gardens,
        //     price: "On Request",
        //     location: "Mumbai",
        //     projectlocation: "Powai, Mumbai",
        //     state: "Mumbai",
        //     developer: "Hiranandani Group",
        //     bed: "3 & 4 BHK Apartments",
        //     size: "On Request",
        //     url: `/developers/birla/birla-estate`,
        //     form: {
        //       source_id: 11,
        //       api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //       sub_source_id: 130,
        //       builder_id: `103`,
        //       project_id: `477`,
        //       subject: "M3M Altitude", // Add or update the subject here
        //       to_email: "jatin.rohilla@propertystation.in",
        //     },
        //   },
          // {
          //   name: "Hiranandani Group - Highland",
          //   image: "",
          //   price: "On Request",
          //   location: "Mumbai",
          //   projectlocation: "Wellesley Road",
          //   state: "Mumbai",
          //   developer: "Hiranandani Group",
          //   bed: "1 - 3 BR Apartments",
          //   size: "On Request",
          //   url: `/developers/birla/birla-estate`,
          //   form: {
          //     source_id: 11,
          //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          //     sub_source_id: 130,
          //     builder_id: `103`,
          //     project_id: `477`,
          //     subject: "M3M Altitude", // Add or update the subject here
          //     to_email: "jatin.rohilla@propertystation.in",
          //   },
          // },
          // {
          //   name: "Hiranandani Group - Empress Hill",
          //   image: Empress,
          //   price: "On Request",
          //   location: "Mumbai",
          //   projectlocation: "Powai, Mumbai",
          //   state: "Mumbai",
          //   developer: "Hiranandani Group",
          //   bed: "2 - 3- 4 BR Apartments",
          //   size: "On Request",
          //   url: `/developers/birla/birla-estate`,
          //   form: {
          //     source_id: 11,
          //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          //     sub_source_id: 130,
          //     builder_id: `103`,
          //     project_id: `477`,
          //     subject: "M3M Altitude", // Add or update the subject here
          //     to_email: "jatin.rohilla@propertystation.in",
          //   },
          // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  
  regenthill: {
    bannerdata:{
      bannerDesktopImage:bannerDesktopImage_regenthill,
      bannerMobileImage:bannerMobileImage_regenthill,
      textOverlay: "",
      data:{
        title:"Hiranandani Regent Hill",
        subtitle:"Powai, Mumbai",
        starting_price:"1.79 Cr",
        rerano:"P51800018620",
        payment_plan:"....",
        status:"Ready To Move"
      }
    },
    overview: {
      heading: "Hiranandani Regent Hill at Powai, Mumbai",
      description: [
      `Hiranandani Regent Hill, developed by the prestigious Hiranandani Group, offers premium 1 BHK apartments in Powai, Mumbai. Designed for modern living, the project features contemporary architecture, spacious layouts, and high-quality finishes.

Located in the heart of Powai, Regent Hill provides excellent connectivity to JVLR, Eastern & Western Express Highways, and key business districts. Residents enjoy close proximity to top educational institutions, healthcare facilities, shopping centers, and entertainment hubs.

The project offers world-class amenities, including a clubhouse, landscaped gardens, a swimming pool, a gym, and 24/7 security, ensuring a comfortable and secure lifestyle. With its prime location and premium features, Hiranandani Regent Hill is an excellent choice for homeowners and investors alike.`,
      ],
      image: overviewImage_regenthill,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_regenthill,
          title: "1.79 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_regenthill,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_regenthill,
          title: "Ready To Move",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_regenthill,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK",
        area: "378.46 - 390 sq. ft.",
        price: "1.79 - 1.85 Cr",
          eoiAmount: "On Request",
        }
      ],
    },

    floor_plan: [
      {
        type: "1 BHK",
        area: "378.46 - 390 sq. ft.",
        price: "1.79 - 1.85 Cr",
        image: image1BHK_regenthill,
      },
      
    ],

    highlights: {
      images: Hightlights_regenthill,
      tagline: "Highlights",
      features: [
        "Providing air-conditioned apartments",
        "Sheer curtain with two tracks",
        "Audio Intercom using IP-EPABX (video call supported)",
        "Every accessibility is just around your doorway",
        "Privileges of modern lifestyle amenities",
      ],
    },

    location: {
      image: Location_regenthill,
      data:[
        {
          airport:{
            distance_time:"10 Km ",
            name:"CSMI Airport"
          },
          school:{
            distance_time:"700 m",
            name:"Foundation School"
          },
          railwayormetro:{
            distance_time:"5 Km",
            name:"Marol Naka Metro Station"
          },
          hospital:{
            distance_time:"5.9 KM",
            name:"Seven Hills Hospital"
          },
          mall:{
            distance_time:"600 m",
            name:"Galleria Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image:g1_regenthill },
        { image:g2_regenthill },
        { image:g3_regenthill },
        { image:g4_regenthill },
        { image:g5_regenthill },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Hiranandani Regent Hill, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of the Regent Hill project?",
        answer: `The developer of the Regent Hill project is the Hiranandani Group.` },
      {
        question: "What is the name of the project?",
        answer: `The name of the project is Regent Hill.
`   },
      {
        question: "Where is Regent Hill located?",
        answer: `Regent Hill is located in Powai, Mumbai.`  },
      {
        question: "What type of apartments are available in Regent Hill?",
        answer: `The project offers 1 BHK apartments.`  },
      {
        question: "What is the area range of the 1 BHK apartments?",
        answer: `The area of the 1 BHK apartments ranges from 378.46 to 390 sq. ft.`  },
      {
        question: "What is the price range of the apartments in Regent Hill?",
        answer: `The price ranges from ₹1.79 Cr to ₹1.85 Cr.`  },
      {
        question: "What is the starting price of an apartment in Regent Hill?",
        answer: `The starting price is ₹1.79 Cr.
`  },
      {
        question: "Which city is Regent Hill situated in?",
        answer: `Regent Hill is situated in Mumbai.`   },
      {
        question: "Which group developed Regent Hill in Powai?",
        answer: `Regent Hill is developed by the Hiranandani Group.`  },
      {
        question: "What is the maximum size of a 1 BHK apartment in Regent Hill?",
        answer: `The maximum size is 390 sq. ft.`   },
    ],
    similar:{
      properties: [
        {
          name: "Hiranandani Group - Vista Residences",
          image:vista,
          price: "On Request",
          location: "West Mumbai",
          bed: "2 - 3 BHK",
          state: "Mumbai",
          developer: "Hiranandani Group",
          size: "....",
          url: `/hiranandani-vista-residences-andheri-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        // {
        //     name: "Hiranandani Group - Gardens",
        //     image:Gardens,
        //     price: "On Request",
        //     location: "Mumbai",
        //     projectlocation: "Powai, Mumbai",
        //     state: "Mumbai",
        //     developer: "Hiranandani Group",
        //     bed: "3 & 4 BHK Apartments",
        //     size: "On Request",
        //     url: `/developers/birla/birla-estate`,
        //     form: {
        //       source_id: 11,
        //       api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //       sub_source_id: 130,
        //       builder_id: `103`,
        //       project_id: `477`,
        //       subject: "M3M Altitude", // Add or update the subject here
        //       to_email: "jatin.rohilla@propertystation.in",
        //     },
        //   },
          // {
          //   name: "Hiranandani Group - Highland",
          //   image: "",
          //   price: "On Request",
          //   location: "Mumbai",
          //   projectlocation: "Wellesley Road",
          //   state: "Mumbai",
          //   developer: "Hiranandani Group",
          //   bed: "1 - 3 BR Apartments",
          //   size: "On Request",
          //   url: `/developers/birla/birla-estate`,
          //   form: {
          //     source_id: 11,
          //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          //     sub_source_id: 130,
          //     builder_id: `103`,
          //     project_id: `477`,
          //     subject: "M3M Altitude", // Add or update the subject here
          //     to_email: "jatin.rohilla@propertystation.in",
          //   },
          // },
          // {
          //   name: "Hiranandani Group - Empress Hill",
          //   image: Empress,
          //   price: "On Request",
          //   location: "Mumbai",
          //   projectlocation: "Powai, Mumbai",
          //   state: "Mumbai",
          //   developer: "Hiranandani Group",
          //   bed: "2 - 3- 4 BR Apartments",
          //   size: "On Request",
          //   url: `/developers/birla/birla-estate`,
          //   form: {
          //     source_id: 11,
          //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
          //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
          //     sub_source_id: 130,
          //     builder_id: `103`,
          //     project_id: `477`,
          //     subject: "M3M Altitude", // Add or update the subject here
          //     to_email: "jatin.rohilla@propertystation.in",
          //   },
          // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
}

